import React from "react";
import Shimmer from "./shimmer/Shimmer";
import useTranslationHook from "../hooks/useTranslationHook";
import { toggleDiscoverModal } from "../../redux/slice/discoverSlice";
import { useDispatch, useSelector } from "react-redux";

const Tabs = ({
    tab,
    data,
    Component,
    className,
    fetchData,
    activeTab,
    view = "grid",
    isLoading = false,
    syncData = [],
    isAuction = false,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslationHook();
    const isSeller = useSelector((state) => state.profile.account) === 1;
    const isClusterPropertyListOpen = useSelector(
        (state) => state.discover.isClusterPropertyListOpen
    );

    return (
        <div {...(isClusterPropertyListOpen && { className: "map-list" })}>
            {isClusterPropertyListOpen && (
                <h5 className="map-heading">
                    {/* The Private Residences */}
                    Properties
                    <button
                        className="close"
                        onClick={() => {
                            dispatch(
                                toggleDiscoverModal({
                                    isClusterPropertyListOpen: false,
                                })
                            );
                        }}
                    >
                        <img src="img/close-gray.svg" alt="" />
                    </button>
                </h5>
            )}

            {isSeller && (
                <ul
                    className="nav nav-pills mb-4"
                    id="pills-tab1"
                    role="tablist"
                >
                    {tab?.map(({ label, key }, index) => (
                        <li
                            className="nav-item"
                            role="presentation"
                            key={index}
                        >
                            <button
                                className={`nav-link ${activeTab === key ? "active" : ""}`}
                                data-bs-toggle="pill"
                                data-bs-target={`#tab-${key}`}
                                type="button"
                                role="tab"
                                aria-controls={`tab-${key}`}
                                aria-selected={activeTab === key}
                                onClick={() => {
                                    if (fetchData) fetchData(key);
                                }}
                            >
                                {t(label)}
                            </button>
                        </li>
                    ))}
                </ul>
            )}

            {isLoading ? (
                [1, 2, 3].map((element, index) => (
                    <Shimmer
                        key={index}
                        type="rectangle"
                        width="31%"
                        height="50vh"
                        borderRadius="10%"
                    />
                ))
            ) : (
                <div className="tab-content" id="pills-tabContent1">
                    {tab?.map(({ key }, index) => (
                        <div
                            key={index}
                            className={`tab-pane fade ${activeTab === key ? "show active" : ""}`}
                            id={`tab-${key}`}
                            role="tabpanel"
                            aria-labelledby={`tab-${key}`}
                        >
                            {view === "list" && (
                                <div className="prop-result">
                                    <h5>Results</h5>
                                    <p>{data?.length || 0} Property</p>
                                </div>
                            )}
                            <ul className={`${className} ${view}`}>
                                {data?.length
                                    ? data?.map((ele, ind) => (
                                          <Component
                                              ele={ele}
                                              key={ind}
                                              view={view}
                                              syncData={
                                                  syncData?.filter(
                                                      ({ property_id }) =>
                                                          property_id ===
                                                          Number(
                                                              ele?.property_id
                                                          )
                                                  )?.[0]
                                              }
                                          />
                                      ))
                                    : view !== "map" && (
                                          <li className="full text-center">
                                              <div className="notproprtyfound">
                                                  <div className="icon mb-3">
                                                      <img
                                                          src="/img/no-property-found.svg"
                                                          alt={t(
                                                              `No ${isAuction ? "auctions" : "properties"} found`
                                                          )}
                                                      />
                                                  </div>
                                                  <h6>
                                                      {t(
                                                          `No ${isAuction ? "auctions" : "properties"} found`
                                                      )}
                                                  </h6>
                                                  <p>
                                                      We couldn’t find any
                                                      results. Make sure your
                                                      input is correct or try
                                                      adjusting your search.
                                                  </p>
                                              </div>
                                          </li>
                                      )}
                            </ul>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default Tabs;
